import { _ as e } from "../internals/export.js";
import { g as r } from "../internals/global.js";
import { g as a } from "../internals/get-built-in.js";
import { f as t } from "../internals/function-uncurry-this.js";
import { f as s } from "../internals/fails.js";
import { u as n } from "../internals/uid.js";
import { i as c } from "../internals/is-callable.js";
import { i as o } from "../internals/is-constructor.js";
import { i } from "../internals/is-null-or-undefined.js";
import { i as f } from "../internals/is-object.js";
import { i as l } from "../internals/is-symbol.js";
import { i as m } from "../internals/iterate.js";
import { a as u } from "../internals/an-object.js";
import { c as y } from "../internals/classof.js";
import { h as b } from "../internals/has-own-property.js";
import { c as p } from "../internals/create-property.js";
import { c as g } from "../internals/create-non-enumerable-property.js";
import { l as h } from "../internals/length-of-array-like.js";
import { v as d } from "../internals/validate-arguments-length.js";
import { r as w } from "../internals/regexp-get-flags.js";
import { m as k } from "../internals/map-helpers.js";
import { s as A } from "../internals/set-helpers.js";
import { e as E } from "../internals/error-stack-installable.js";
import { s as j } from "../internals/structured-clone-proper-transfer.js";
var v = r.Object,
  D = r.Array,
  O = r.Date,
  M = r.Error,
  B = r.EvalError,
  S = r.RangeError,
  x = r.ReferenceError,
  C = r.SyntaxError,
  R = r.TypeError,
  I = r.URIError,
  U = r.PerformanceMark,
  F = r.WebAssembly,
  T = F && F.CompileError || M,
  L = F && F.LinkError || M,
  P = F && F.RuntimeError || M,
  V = a("DOMException"),
  H = k.Map,
  z = k.has,
  W = k.get,
  G = k.set,
  Q = A.Set,
  q = A.add,
  K = a("Object", "keys"),
  N = t([].push),
  _ = t((!0).valueOf),
  J = t(1..valueOf),
  X = t("".valueOf),
  Y = t(O.prototype.getTime),
  Z = n("structuredClone"),
  $ = "DataCloneError",
  ee = "Transferring",
  er = function er(e) {
    return !s(function () {
      var a = new r.Set([7]),
        t = e(a),
        s = e(v(7));
      return t == a || !t.has(7) || "object" != typeof s || 7 != s;
    }) && e;
  },
  ea = function ea(e, r) {
    return !s(function () {
      var a = new r(),
        t = e({
          a: a,
          b: a
        });
      return !(t && t.a === t.b && t.a instanceof r && t.a.stack === a.stack);
    });
  },
  et = r.structuredClone,
  es = !ea(et, M) || !ea(et, V) || !!s(function () {
    var e = et(new r.AggregateError([1], Z, {
      cause: 3
    }));
    return "AggregateError" != e.name || 1 != e.errors[0] || e.message != Z || 3 != e.cause;
  }),
  en = !et && er(function (e) {
    return new U(Z, {
      detail: e
    }).detail;
  }),
  ec = er(et) || en,
  eo = function eo(e) {
    throw new V("Uncloneable type: " + e, $);
  },
  ei = function ei(e, r) {
    throw new V((r || "Cloning") + " of " + e + " cannot be properly polyfilled in this engine", $);
  },
  ef = function ef(e, r) {
    return ec || ei(r), ec(e);
  },
  el = function el() {
    var e;
    try {
      e = new r.DataTransfer();
    } catch (a) {
      try {
        e = new r.ClipboardEvent("").clipboardData;
      } catch (e) {}
    }
    return e && e.items && e.files ? e : null;
  },
  em = function em(e, a, t) {
    if (z(a, e)) return W(a, e);
    if ("SharedArrayBuffer" === (t || y(e))) s = ec ? ec(e) : e;else {
      var s,
        n,
        c,
        o,
        i,
        f,
        l = r.DataView;
      l || "function" == typeof e.slice || ei("ArrayBuffer");
      try {
        if ("function" != typeof e.slice || e.resizable) for (f = 0, n = e.byteLength, c = ("maxByteLength" in e) ? {
          maxByteLength: e.maxByteLength
        } : void 0, s = new ArrayBuffer(n, c), o = new l(e), i = new l(s); f < n; f++) i.setUint8(f, o.getUint8(f));else s = e.slice(0);
      } catch (e) {
        throw new V("ArrayBuffer is detached", $);
      }
    }
    return G(a, e, s), s;
  },
  eu = function eu(e, a, t, s, n) {
    var c = r[a];
    return f(c) || ei(a), new c(em(e.buffer, n), t, s);
  },
  ey = function ey(e, r, a) {
    this.object = e, this.type = r, this.metadata = a;
  },
  eb = function eb(e, t, s) {
    if (l(e) && eo("Symbol"), !f(e)) return e;
    if (t) {
      if (z(t, e)) return W(t, e);
    } else t = new H();
    var n,
      o,
      i,
      m,
      u,
      d,
      k,
      A,
      j = y(e);
    switch (j) {
      case "Array":
        i = D(h(e));
        break;
      case "Object":
        i = {};
        break;
      case "Map":
        i = new H();
        break;
      case "Set":
        i = new Q();
        break;
      case "RegExp":
        i = new RegExp(e.source, w(e));
        break;
      case "Error":
        switch (o = e.name) {
          case "AggregateError":
            i = a("AggregateError")([]);
            break;
          case "EvalError":
            i = B();
            break;
          case "RangeError":
            i = S();
            break;
          case "ReferenceError":
            i = x();
            break;
          case "SyntaxError":
            i = C();
            break;
          case "TypeError":
            i = R();
            break;
          case "URIError":
            i = I();
            break;
          case "CompileError":
            i = T();
            break;
          case "LinkError":
            i = L();
            break;
          case "RuntimeError":
            i = P();
            break;
          default:
            i = M();
        }
        break;
      case "DOMException":
        i = new V(e.message, e.name);
        break;
      case "ArrayBuffer":
      case "SharedArrayBuffer":
        i = s ? new ey(e, j) : em(e, t, j);
        break;
      case "DataView":
      case "Int8Array":
      case "Uint8Array":
      case "Uint8ClampedArray":
      case "Int16Array":
      case "Uint16Array":
      case "Int32Array":
      case "Uint32Array":
      case "Float16Array":
      case "Float32Array":
      case "Float64Array":
      case "BigInt64Array":
      case "BigUint64Array":
        d = "DataView" === j ? e.byteLength : e.length, i = s ? new ey(e, j, {
          offset: e.byteOffset,
          length: d
        }) : eu(e, j, e.byteOffset, d, t);
        break;
      case "DOMQuad":
        try {
          i = new DOMQuad(eb(e.p1, t, s), eb(e.p2, t, s), eb(e.p3, t, s), eb(e.p4, t, s));
        } catch (r) {
          i = ef(e, j);
        }
        break;
      case "File":
        if (ec) try {
          i = ec(e), y(i) !== j && (i = void 0);
        } catch (e) {}
        if (!i) try {
          i = new File([e], e.name, e);
        } catch (e) {}
        i || ei(j);
        break;
      case "FileList":
        if (m = el()) {
          for (u = 0, d = h(e); u < d; u++) m.items.add(eb(e[u], t, s));
          i = m.files;
        } else i = ef(e, j);
        break;
      case "ImageData":
        try {
          i = new ImageData(eb(e.data, t, s), e.width, e.height, {
            colorSpace: e.colorSpace
          });
        } catch (r) {
          i = ef(e, j);
        }
        break;
      default:
        if (ec) i = ec(e);else switch (j) {
          case "BigInt":
            i = v(e.valueOf());
            break;
          case "Boolean":
            i = v(_(e));
            break;
          case "Number":
            i = v(J(e));
            break;
          case "String":
            i = v(X(e));
            break;
          case "Date":
            i = new O(Y(e));
            break;
          case "Blob":
            try {
              i = e.slice(0, e.size, e.type);
            } catch (e) {
              ei(j);
            }
            break;
          case "DOMPoint":
          case "DOMPointReadOnly":
            n = r[j];
            try {
              i = n.fromPoint ? n.fromPoint(e) : new n(e.x, e.y, e.z, e.w);
            } catch (e) {
              ei(j);
            }
            break;
          case "DOMRect":
          case "DOMRectReadOnly":
            n = r[j];
            try {
              i = n.fromRect ? n.fromRect(e) : new n(e.x, e.y, e.width, e.height);
            } catch (e) {
              ei(j);
            }
            break;
          case "DOMMatrix":
          case "DOMMatrixReadOnly":
            n = r[j];
            try {
              i = n.fromMatrix ? n.fromMatrix(e) : new n(e);
            } catch (e) {
              ei(j);
            }
            break;
          case "AudioData":
          case "VideoFrame":
            c(e.clone) || ei(j);
            try {
              i = e.clone();
            } catch (e) {
              eo(j);
            }
            break;
          case "CropTarget":
          case "CryptoKey":
          case "FileSystemDirectoryHandle":
          case "FileSystemFileHandle":
          case "FileSystemHandle":
          case "GPUCompilationInfo":
          case "GPUCompilationMessage":
          case "ImageBitmap":
          case "RTCCertificate":
          case "WebAssembly.Module":
            ei(j);
          default:
            eo(j);
        }
    }
    switch (G(t, e, i), j) {
      case "Array":
      case "Object":
        for (u = 0, d = h(k = K(e)); u < d; u++) A = k[u], p(i, A, eb(e[A], t, s));
        break;
      case "Map":
        e.forEach(function (e, r) {
          G(i, eb(r, t, s), eb(e, t, s));
        });
        break;
      case "Set":
        e.forEach(function (e) {
          q(i, eb(e, t, s));
        });
        break;
      case "Error":
        g(i, "message", eb(e.message, t, s)), b(e, "cause") && g(i, "cause", eb(e.cause, t, s)), "AggregateError" == o && (i.errors = eb(e.errors, t, s));
      case "DOMException":
        E && g(i, "stack", eb(e.stack, t, s));
    }
    return i;
  },
  ep = function ep(e, r) {
    var a, t, s, n, c, o, i, l;
    if (!f(e)) return e;
    if (z(r, e)) return W(r, e);
    if (e instanceof ey) switch (a = e.type, t = e.object, a) {
      case "ArrayBuffer":
      case "SharedArrayBuffer":
        l = em(t, r, a);
        break;
      case "DataView":
      case "Int8Array":
      case "Uint8Array":
      case "Uint8ClampedArray":
      case "Int16Array":
      case "Uint16Array":
      case "Int32Array":
      case "Uint32Array":
      case "Float16Array":
      case "Float32Array":
      case "Float64Array":
      case "BigInt64Array":
      case "BigUint64Array":
        l = eu(t, a, (s = e.metadata).offset, s.length, r);
    } else switch (y(e)) {
      case "Array":
      case "Object":
        for (n = 0, c = h(o = K(e)); n < c; n++) e[i = o[n]] = ep(e[i], r);
        break;
      case "Map":
        l = new H(), e.forEach(function (e, a) {
          G(l, ep(a, r), ep(e, r));
        });
        break;
      case "Set":
        l = new Q(), e.forEach(function (e) {
          q(l, ep(e, r));
        });
        break;
      case "Error":
        e.message = ep(e.message, r), b(e, "cause") && (e.cause = ep(e.cause, r)), "AggregateError" == e.name && (e.errors = ep(e.errors, r));
      case "DOMException":
        E && (e.stack = ep(e.stack, r));
    }
    return G(r, e, l || e), l || e;
  },
  eg = function eg(e, a) {
    if (!f(e)) throw R("Transfer option cannot be converted to a sequence");
    var t,
      s,
      n,
      i,
      l,
      b = [];
    m(e, function (e) {
      N(b, u(e));
    });
    for (var p = 0, g = h(b), d = []; p < g;) {
      if ("ArrayBuffer" === (s = y(t = b[p++]))) {
        N(d, t);
        continue;
      }
      if (z(a, t)) throw new V("Duplicate transferable", $);
      if (j) i = et(t, {
        transfer: [t]
      });else switch (s) {
        case "ImageBitmap":
          o(n = r.OffscreenCanvas) || ei(s, ee);
          try {
            (l = new n(t.width, t.height)).getContext("bitmaprenderer").transferFromImageBitmap(t), i = l.transferToImageBitmap();
          } catch (e) {}
          break;
        case "AudioData":
        case "VideoFrame":
          c(t.clone) && c(t.close) || ei(s, ee);
          try {
            i = t.clone(), t.close();
          } catch (e) {}
          break;
        case "MediaSourceHandle":
        case "MessagePort":
        case "OffscreenCanvas":
        case "ReadableStream":
        case "TransformStream":
        case "WritableStream":
          ei(s, ee);
      }
      if (void 0 === i) throw new V("This object cannot be transferred: " + s, $);
      G(a, t, i);
    }
    return d;
  },
  eh = function eh(e, r) {
    for (var a, t, s = 0, n = h(e); s < n;) {
      if (z(r, a = e[s++])) throw new V("Duplicate transferable", $);
      j ? t = et(a, {
        transfer: [a]
      }) : (c(a.transfer) || ei("ArrayBuffer", ee), t = a.transfer()), G(r, a, t);
    }
  };
e({
  global: !0,
  enumerable: !0,
  sham: !j,
  forced: es
}, {
  structuredClone: function structuredClone(e) {
    var r,
      a = d(arguments.length, 1) > 1 && !i(arguments[1]) ? u(arguments[1]) : void 0,
      t = a ? a.transfer : void 0,
      s = !1;
    void 0 !== t && (s = !!h(eg(t, r = new H())));
    var n = eb(e, r, s);
    return s && (eh(t, r = new H()), n = ep(n, r)), n;
  }
});